// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    ACTIVITIES_TAB_SEARCH_REQUEST,
    ACTIVITIES_TAB_SEARCH_USERS_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    activitiesSearchDataResult,
    activitiesSearchUsersTabResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* searchAuditlogs({ payload }) {
    try {
        let QUERY = `
            query searchAuditlogs ($accountId: String, $entity: EntityAuditLogInput, $action: [String], $opensearch: [String], $username: String, $dateRange: AWSDateTimeRange, $nextToken: String, $lastRecords: Int) {
                result: searchAuditlogs (accountId: $accountId, entity: $entity, action: $action, opensearch: $opensearch, username: $username, dateRange: $dateRange, nextToken: $nextToken, lastRecords: $lastRecords) {
                    items {
                        id
                        source
                        urlReferrer
                        module
                        method
                        ipAddress
                        platform
                        entityName
                        entityId
                        accountId
                        action
                        newValues
                        parameters
                        updatedBy
                        updatedOn
                        username
                    }
                    nextToken
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload.filters,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data.result) {
            yield put(activitiesSearchDataResult({ 
                activities: data?.result?.items, 
                nextToken: data?.result?.nextToken, 
                oldNextToken: payload?.filters?.nextToken, 
                entity: payload?.entity,
                instanceId: payload?.instanceId 
            }))
        } else {
            yield put(activitiesSearchDataResult({ error: true, instanceId: payload?.instanceId }))
        }

    } catch (exc) {
        yield put(activitiesSearchDataResult({ error: true, instanceId: payload?.instanceId }))
        //ExceptionManager(exc, 'Modules/activities/.components/tab/redux/saga', 'searchAuditlogs');
    }
}

function* searchUsers({ payload }) {
    const { entity, filters, companyName } = payload
    try {
        let QUERY = `
        query searchSubUsers ($conditions: [SubUserSearchInput], $sort: [SubUserSortInput], $limit: Int, $offset: Int) {
            result: searchSubUsers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    userName
                }
            }
        }
        `;
        let conditions = [];

        if (entity === "companyId") {
            conditions.push({
                fields: ["companyId"],
                terms: [filters],
                exact: true,
            })
        }
        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: conditions,
                sort: {
                    field: "userName",
                    order: "ASC"
                },
                limit: 500,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let users = JSON.parse(JSON.stringify(data?.result?.items))
            users.unshift({ id: filters, userName: companyName })
            yield put(activitiesSearchUsersTabResult({ users: users }))
        }

    } catch (exc) {
        yield put(activitiesSearchUsersTabResult({ error: true }))
        ExceptionManager(exc, 'Modules/activities/views/main/redux/saga', 'searchUsers');
    }
}


function* watchMethods() {
    yield takeEvery(ACTIVITIES_TAB_SEARCH_REQUEST, searchAuditlogs);
    yield takeEvery(ACTIVITIES_TAB_SEARCH_USERS_REQUEST, searchUsers);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}